import { Col, Input, Label } from "reactstrap";
import { CheckedCheckbox, DefaultCheck, Defaultcheckboxes } from "../../../../Constant";
import { H6 } from "../../../../AbstractElements";

export const DefaultChecks = () => {
  return (
    <Col sm="6" xl="4">
      <div className="card-wrapper border rounded-3 checkbox-checked">
        <H6 className="sub-title">{DefaultCheck}</H6>
        <div className="form-check">
          <Input id="flexCheckDefault" type="checkbox" />
          <Label htmlFor="flexCheckDefault" check>
            {Defaultcheckboxes}
          </Label>
        </div>
        <div className="form-check">
          <Input id="flexCheckChecked" type="checkbox" defaultChecked />
          <Label htmlFor="flexCheckChecked" check>
            {CheckedCheckbox}
          </Label>
        </div>
      </div>
    </Col>
  );
};
